/* eslint-disable no-unused-vars */
var PowerPoint = window.PowerPoint;
const Office = window.Office;

import JSZip from "jszip";
import { insertImageByCompletionUrl } from "./gpt_image.js"
import { axiosInstance as axios } from "@/utils/wd_axios.js";
import { gptPubIds, actionUniform, actionMenuPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
import { i18n } from "@i18n";
import {
  az_genereate_imageUrl,
  az_genereate_iconUrl,
  az_download_image,
} from "@/pptjs/api/api_azure_openai.js";

import { Rect, placeShape } from "@/views/gpt/util/findSpaceforNewShape.js";

// VSTO Host Object
import store from "@store";
// import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");

export async function insert_slide_byTemplateFile(url) {
  let response = await axios.get(url, { responseType: "blob" });
  let base64Data;
  await new Promise((resolve, reject) => {
    let oFileReader = new FileReader();
    oFileReader.onloadend = function (e) {
      // base64结果
      base64Data = e.target.result;
      resolve(true);
    };
    oFileReader.readAsDataURL(response.data);
  });
  let newSlide = await insertSlide_byBase64(base64Data);
  return newSlide;
}

async function insertSlide_byBase64(base64Data) {
  PowerPoint = window.PowerPoint
  const startIndex = base64Data.indexOf("base64,");
  const chosenFileBase64 = base64Data.substr(startIndex + 7);
  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation;
      let slides = presentation.slides;

      /** get current selected slide */
      let currentSlideId = null;
      let selectedSlides = presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      if (selectedSlides.items.length > 0) {
        let currentSlide = selectedSlides.items[0];
        currentSlide.load("id");
        await context.sync();
        currentSlideId = currentSlide.id;
      }

      /** 如何确保生成过程中，用户切换了选中slide，这时候需要判断的是，之前是否插入过，如果插入过则就在之前那一页后面继续插入，不要受到用户当前选择影响 */
      let preInsertSlideId = store.get('gpt/currentSlideId');
      if (preInsertSlideId) {
        currentSlideId = preInsertSlideId
      }

      /**
       * insert slide
       * targetSlideId： means will insert follow this slide
       */
      let insertOptions = null;
      if (currentSlideId === null) {
        insertOptions = {
          formatting: "KeepSourceFormatting",
        };
      } else {
        insertOptions = {
          formatting: "KeepSourceFormatting",
          targetSlideId: currentSlideId,
        };
      }
      presentation.insertSlidesFromBase64(chosenFileBase64, insertOptions);

      /**
       * find new slide, set the new slide selected
       */
      slides.load("items");
      await context.sync();
      let slidesItems = slides.items
      let newSlideIndex = 0
      for (let index = 0; index < slidesItems.length; index++) {
        const element = slidesItems[index];
        element.load('id')
        await context.sync()
        if (element.id === currentSlideId) {
          newSlideIndex = index + 1
        }
      }
      let newLastSlide = slidesItems[newSlideIndex]
      newLastSlide.load('id')
      await context.sync()
      let newSlideId = newLastSlide.id

      presentation.setSelectedSlides([newSlideId]);
      await context.sync();

      store.set("gpt/currentSlideId", newSlideId);
      store.set("gpt/currentSlideIndex", newSlideIndex);

      return newLastSlide;
    });
  } catch (error) {
    console.log("insertSlide_byBase64: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}
// 将 Base64 转换为 ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64); // 解码 Base64
  const length = binaryString.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// 预览模板，根据ID替换幻灯片，如果ID为空，就插入一页新的幻灯片
export async function preViewTemplate(currentId, newTempalteFileName) {
  let templateUrl = ''
  if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic))) {
    templateUrl = `/layout/template_semantic/${newTempalteFileName}.pptx`
  } else if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic_whole))) {
    templateUrl = `/layout/template_semantic_whole/${newTempalteFileName}.pptx`
  } else {
    templateUrl = `/layout/template_title_contents/${newTempalteFileName}.pptx`
  }
  let response = await axios.get(`${wdConfigData.baseURLTemplate}/${templateUrl}`, { responseType: "blob" })
  let base64Data
  await new Promise((resolve, reject) => {
    let oFileReader = new FileReader()
    oFileReader.onloadend = function (e) {
      base64Data = e.target.result
      resolve(true)
    };
    oFileReader.readAsDataURL(response.data)
  });

  PowerPoint = window.PowerPoint
  const startIndex = base64Data.indexOf("base64,")
  const chosenFileBase64 = base64Data.substr(startIndex + 7)

  // get slide count
  const arrayBuffer = base64ToArrayBuffer(chosenFileBase64);
  const zip = await JSZip.loadAsync(arrayBuffer);
  const slideFiles = Object.keys(zip.files).filter(name => name.startsWith('ppt/slides/slide'));
  const slideCount = slideFiles.length;

  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation
      let slides = presentation.slides
      let currentSlide = null

      if (currentId) {
        // 根据currentId找到这个Slide，然后找到前一个SlideId, 删除currentId对应的Slide，在前一个SlideId后面插入新的templateFlieName对应的Slide
        presentation.load("slides")
        await context.sync()
        let allSlideCollections = presentation.slides
        allSlideCollections.load("items")
        await context.sync()
        let allSlides = allSlideCollections.items

        let preSlideId = null
        for (let i = 0; i < allSlides.length; i++) {
          const element = allSlides[i]
          element.load('id')
          await context.sync()
          if (element.id === currentId) {
            currentSlide = element
            if (i > 0) {
              let preElement = allSlides[i - 1]
              preElement.load('id')
              await context.sync()
              preSlideId = preElement.id
              break
            } else {
              preSlideId = element.id
            }
          }
        }

        /**
         * insert slide
         * targetSlideId： means will insert follow this slide
         */
        if (!preSlideId) {
          let selectedSlides = presentation.getSelectedSlides()
          selectedSlides.load("items")
          await context.sync()
          let currentSlide = selectedSlides.items[0]
          currentSlide.load("id")
          await context.sync()
          preSlideId = currentSlide.id
        }
        let insertOptions = {
          formatting: "KeepSourceFormatting",
          targetSlideId: preSlideId
        };
        presentation.insertSlidesFromBase64(chosenFileBase64, insertOptions)

        /**
         * find new slide, set the new slide selected
         */
        slides.load("items")
        await context.sync()
        let slidesItems = slides.items
        let newSlideIndex = 0
        for (let index = 0; index < slidesItems.length; index++) {
          const element = slidesItems[index];
          element.load('id')
          await context.sync()
          if (element.id === preSlideId) {
            newSlideIndex = index + 1
          }
        }
        let newLastSlide = slidesItems[newSlideIndex]
        newLastSlide.load('id')
        await context.sync()
        let newSlideId = newLastSlide.id

        presentation.setSelectedSlides([newSlideId])
        await context.sync()

        // delete pre PreviewSlide
        if (currentSlide) {
          currentSlide.delete()
          await context.sync()
        }

        store.set("gpt/currentPreviewSlideId", newSlideId)

        // 如果选择预览的是全套语义模板，则需要保存当前预览的模板每一页Slide的ID，便于后续使用
        if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic_whole))) {
          let previewSlides = []
          for (let index = 0; index < slideCount; index++) {
            let previewSlide = {
              Index: index,
              SlideId: slidesItems[newSlideIndex + index].id
            }
            previewSlides.push(previewSlide)
          }
          store.set("gpt/currentSelectedSemanticTemplateWhole", JSON.stringify(previewSlides))
        }
      } else {
        // 当前没有预览中的Slide，直接在当前Slide后插入templateFlieName对应的Slide
        /** get current selected slide */
        let currentSlideId = null;
        let selectedSlides = presentation.getSelectedSlides()
        selectedSlides.load("items")
        await context.sync()
        let currentSlide = selectedSlides.items[0]
        currentSlide.load("id")
        await context.sync()
        currentSlideId = currentSlide.id

        /**
         * insert slide
         * targetSlideId： means will insert follow this slide
         */
        let insertOptions = {
          formatting: "KeepSourceFormatting",
          targetSlideId: currentSlideId
        };
        presentation.insertSlidesFromBase64(chosenFileBase64, insertOptions)

        /**
         * find new slide, set the new slide selected
         */
        slides.load("items")
        await context.sync()
        let slidesItems = slides.items
        let newSlideIndex = 0
        for (let index = 0; index < slidesItems.length; index++) {
          const element = slidesItems[index]
          element.load('id')
          await context.sync()
          if (element.id === currentSlideId) {
            newSlideIndex = index + 1
          }
        }
        let newLastSlide = slidesItems[newSlideIndex]
        newLastSlide.load('id')
        await context.sync()
        let newSlideId = newLastSlide.id

        presentation.setSelectedSlides([newSlideId])
        await context.sync();

        store.set("gpt/currentPreviewSlideId", newSlideId)

        // 如果选择预览的是全套语义模板，则需要保存当前预览的模板每一页Slide的ID，便于后续使用
        if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic_whole))) {
          let previewSlides = []
          for (let index = 0; index < slideCount; index++) {
            let previewSlide = {
              Index: index,
              SlideId: slidesItems[newSlideIndex + index].id
            }
            previewSlides.push(previewSlide)
          }
          store.set("gpt/currentSelectedSemanticTemplateWhole", JSON.stringify(previewSlides))
        }
      }
    });
  } catch (error) {
    console.log("preViewTemplate");
  }
}

export async function savePreviewTemplateShapeData() {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      /**
       * 根据当前预览ID确认当前slides中是否存在预览的这一页slide
       * 存在，则正常读取这一页的shape结构，注意这一步不要读取当前选中的slide，用户可能会快速切换了选中效果
       * 不存在，则提示用户当前预览的模板不存在，请重新选择，重置存储为null
       * 
       * shapeData只存储需要的结构，也就是带有文本内容的结构，不需要识别空白结构，比如一个TextBox但是里面没有任何内容，因为AI也无法判断这个TextBox应该承担何种角色
       * 如果遇到了空白或者不包含文字的shape，则需要直接掠过
       * 
       * 注意最终生成时，需要找到currentID对应的slide进行填充内容
       * 任然会遇到找到slide的情况，可能被用户误删除了，这时候应该按照currentTemplateFileName重新插入这一页模板，然后插入文本
       * 如果这时候找不到currentTemplateFileName，就提示用户出现错误，重新选择
       * 
       * 注意从这个版本开始，message log需要有两个数据源，1原始数据，2界面数据；
       * 有部分消息数据，原始数据和界面数据是一致的
       * 每次原始数据有更新的时候，必须同步更新界面数据
       *  */
      let slideCollections = context.presentation.slides
      slideCollections.load('items')
      await context.sync()
      let allSlides = slideCollections.items
      let currentSlide = null

      for (let i = 0; i < allSlides.length; i++) {
        const element = allSlides[i]
        element.load('id')
        await context.sync()
        if (element.id === store.get('gpt/currentPreviewSlideId')) currentSlide = element
      }

      if (currentSlide) {
        // 找到了，开始读取这个slide的shapeData
        let slideData = await getSlideJSONData(context, currentSlide)

        /** Only for hasText shape */
        let allTextSlideData = slideData.filter(item => item.SC.length > 0 && !(item.ST == 'GeometricShape' && (item.SN.includes('Action Button') || item.SN.includes('动作按钮'))))

        localStorage.setItem(userKeys.key_user_settings_preview_template_shape_data, JSON.stringify(allTextSlideData))
        if (JSON.parse(localStorage.getItem(userKeys.key_user_generate_slide_is_change_one_page_template))) {
          publish(actionMenuPubIds.pubId_Action_Menu_Change_OnePage_Template, {})
        }
      } else {
        // 在所有slides中没有找到当前选择的预览模板，生成好PPT内容之后，可以根据当前保存的模板fileName和slidId在模板库中找到这个slide，重新插入这页模板再生成内容

      }
    });
  } catch (error) {
    console.log("savePreviewTemplateShapeData");
  }
}


/**
 * updata template slide data after generate
 */
export async function updateTemplateSlideDatafromJSONData(slideJSONDataString, slideId) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let slideCollections = context.presentation.slides
      slideCollections.load('items')
      await context.sync()
      let allSlides = slideCollections.items
      let slideJSONData = []
      try {
        slideJSONData = JSON.parse(slideJSONDataString)
      } catch (error) {
        console.log('updateTemplateSlideDatafromJSONData: ', error)
        publish(gptPubIds.pubId_Local_PPT_init_error, error)
      }
      /**
       * 找打currentSlideId对应的slide
       * 找到则开始插入
       * 找不到则需要根据templateFlieName插入这一页slide，然后再插入内容
       * 
       * 插入内容时候仍然需要考虑shape的重复和顺序问题
       */
      let currentSlide = null

      for (let i = 0; i < allSlides.length; i++) {
        const element = allSlides[i]
        element.load('id')
        await context.sync()
        if (element.id === slideId) currentSlide = element
      }

      if (!currentSlide) {
        await insertTemplateSlide()
        let selectedSlides = context.presentation.getSelectedSlides();
        selectedSlides.load("items");
        await context.sync();
        currentSlide = selectedSlides.items[0];
      }

      currentSlide.load('id')
      await context.sync()
      context.presentation.setSelectedSlides([currentSlide.id]);
      await context.sync();

      currentSlide.load('shapes')
      await context.sync()
      const shapeCollections = currentSlide.shapes
      shapeCollections.load('items')
      await context.sync()
      let elementShaps = shapeCollections.items
      if (elementShaps.length > 0 && slideJSONData.length > 0) {
        for (let i = 0; i < slideJSONData.length; i++) {
          slideJSONData[i].U = false
        }
        for (let shapeIndex = 0; shapeIndex < elementShaps.length; shapeIndex++) {
          const shape = elementShaps[shapeIndex]
          shape.load('$all')
          await context.sync()

          // 按照模板结构，如果模板结构中存在没有说明的shape,则直接忽略
          let text = null
          if (shapeIsTextType(shape.type, shape.name)) {
            let textFrame = shape.textFrame;
            textFrame.load("hasText")
            await context.sync()
            if (textFrame.hasText) {
              textFrame.load("textRange")
              await context.sync()
              let textRange = textFrame.textRange
              textRange.load("$all")
              await context.sync()
              text = textRange.text

              // textRange.load("font", "text", "size", "italic", "color", "bold")
              // await context.sync()

              // var textRangeTextFont = textRange.font
              // 设置大小、斜体、颜色、加粗
              // textRangeTextFont.size = textRangeTextFont.size
              // textRangeTextFont.italic = false
              // textRangeTextFont.color = "blue"
              // textRangeTextFont.bold = false
            }
          }

          let shapeData = null
          if (text) {
            for (let j = 0; j < slideJSONData.length; j++) {
              if (slideJSONData[j].ST === shape.type && slideJSONData[j].SN === shape.name && !slideJSONData[j].U) {
                shapeData = slideJSONData[j]
                slideJSONData[j].U = true
                break
              }
            }
          }
          if (shapeData && shapeIsTextType(shape.type, shape.name)) {
            let textFrame = shape.textFrame;
            textFrame.load("hasText")
            await context.sync()
            if (textFrame.hasText) {
              // if (shape.name.startsWith("Title") || shape.name.startsWith("标题")) {
              //   textFrame.load("textRange")
              //   await context.sync()
              //   let textRange = textFrame.textRange
              //   textRange.load("$all")
              //   await context.sync()
              //   if (textRange.text) {
              //     textRange.text = shapeData.SC.replace(/\*\*\*###/g, '\r')
              //   }
              //   await context.sync()
              // } else if (
              //   shape.name.startsWith("Content") ||
              //   shape.name.startsWith("Text") ||
              //   shape.name.startsWith("内容") || 
              //   shape.name.startsWith("文本") || shape.name.startsWith("Rectangle") 
              // ) {
              // shape.load("height", "left", "top", "width")
              // await context.sync()
              // if (shape.height < 320) {
              //   shape.height = 320
              // }
              // await context.sync()

              textFrame.load("textRange", 'autoSizeSetting')
              await context.sync()

              textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape
              await context.sync();

              let textRange = textFrame.textRange
              textRange.load("$all")
              await context.sync()
              if (textRange.text) {
                textRange.text = shapeData.SC.replace(/\*\*\*###/g, '\r')
              }
              await context.sync()
              // }
            }
          }
        }
      }
    })
  } catch (error) {
    console.log("updateAllSlideDatafromJSONData:: " + error);
    // publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

async function insertTemplateSlide() {
  if (store.get('gpt/selectedTaskType') && store.get('gpt/selectedTaskType').id === 'task_one_page_general' && store.get('gpt/currentSelectedTemplateName')) {
    let templateName = store.get('gpt/currentSelectedTemplateName')
    let templateUrl = ''
    if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic))) {
      templateUrl = `/layout/template_semantic/${templateName}.pptx`
    } else {
      templateUrl = `/layout/template_title_contents/${templateName}.pptx`
    }
    if (vstoMode) {
      // todo
      // let index = await hostObject_slides.vsto_insertSlideFromUrl(
      //   `${wdConfigData.baseURLTemplate}/${templateUrl}`
      // );
      // await hostObject_shapes.vsto_updateSlideContent_ClassicCanvans(slideData);
    } else {
      await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    }
  } else {
    // todo：error msg
  }
}

export async function get_slide_byTemplateFile(url) {
  let response = await axios.get(url, { responseType: "blob" });
  let base64Data;
  await new Promise((resolve, reject) => {
    let oFileReader = new FileReader();
    oFileReader.onloadend = function (e) {
      // base64结果
      base64Data = e.target.result;
      resolve(true);
    };
    oFileReader.readAsDataURL(response.data);
  });
  return base64Data;
}

export async function generateImageUrl(inputText) {
  let params = {
    inputText: inputText,
    taskType: "task_generate_image",
  };
  let imageUrl = "";
  await az_genereate_imageUrl(params).then((res) => {
    if (res.data.Code == 0) {
      imageUrl = res.data.Result.ImageUrl;
    } else {
      publish(gptPubIds.pubId_Local_PPT_image_generate_error, "");
    }
  });
  return imageUrl;
}

export async function insertImageByUrl(imageUrl, options, radiusType) {
  // 下载并裁剪图片
  let params = {
    imageUrl: imageUrl,
    width: parseInt(options.imageWidth),
    height: parseInt(options.imageHeight),
    radiusType: radiusType, // 0-直角；1-圆角；2-圆
    scaleType: 10, // 0-default; 传10
    cropLocationAlign: 32, // 1-左上，2-上中，4-右上，16-左中, 32-从中心开始取， 64-右中， 256-左下，512-中下，1024-右下
  };
  let base64Data = "";
  await az_download_image(params).then((response) => {
    base64Data = response.data.result;
  });
  if (base64Data && base64Data.length < 0) {
    return;
  }

  // 插入图片
  if (vstoMode) {
    await hostObject_shapes.vsto_insertImageInCurSlideFromData(
      base64Data,
      JSON.stringify(options)
    );
  } else {
    await new Promise((resolve, reject) => {
      Office.context.document.setSelectedDataAsync(
        base64Data,
        options,
        function (asyncResult) {
          if (asyncResult.status === Office.AsyncResultStatus.Failed) {
            reject(console.error(asyncResult.error.message));
          } else {
            resolve("Success");
          }
        }
      );
    });
  }
}

export async function generateIconUrl(inputText) {
  let params = {
    inputText: inputText,
  };
  let imageUrl = "";
  await az_genereate_iconUrl(params).then((res) => {
    imageUrl = res.data.result;
  });
  return imageUrl;
}

export async function insertTextBox(text, options) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      let textBox = shapeCollection.addTextBox(text, options);
      await context.sync();
      return textBox;
    });
  } catch (error) {
    console.log("insertTextBox");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

export async function getSlideImageOptions() {
  PowerPoint = window.PowerPoint
  let options = {
    coercionType: Office.CoercionType.Image,
    imageLeft: 480,
    imageTop: 70,
    imageWidth: 400,
    imageHeight: 400,
  };
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      // shape数组数据
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shape.type == "GeometricShape") {
          // shape text frame
          let textFrame = shape.textFrame;
          // text range
          textFrame.load("textRange");
          await context.sync();
          let textRange = textFrame.textRange;
          textRange.load("$all");
          await context.sync();
          // 更改文本
          if (shape.name.startsWith("Content")) {
            options.imageLeft = shape.left;
            options.imageTop = shape.top;
            options.imageWidth = shape.width;
            options.imageHeight = shape.height;

            shape.delete();
            await context.sync();
          }
        } else if (shape.type == "Image") {
          options.imageLeft = shape.left;
          options.imageTop = shape.top;
          options.imageWidth = shape.width;
          options.imageHeight = shape.height;

          shape.delete();
          await context.sync();
        }
      }
    });
  } catch (error) {
    console.log("getSlideImageOptions");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return options;
}

export async function getSelectedImageOptions() {
  PowerPoint = window.PowerPoint
  let options = {
    coercionType: Office.CoercionType.Image,
    imageLeft: 480,
    imageTop: 70,
    imageWidth: 400,
    imageHeight: 400,
  };
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      // shape数组数据
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        // if (shape.type == "GeometricShape") {
        //   // shape text frame
        //   let textFrame = shape.textFrame;
        //   // text range
        //   textFrame.load("textRange");
        //   await context.sync();
        //   let textRange = textFrame.textRange;
        //   textRange.load("$all");
        //   await context.sync();
        //   // 更改文本
        //   if (shape.name.startsWith("Content")) {
        //     options.imageLeft = shape.left;
        //     options.imageTop = shape.top;
        //     options.imageWidth = shape.width;
        //     options.imageHeight = shape.height;

        //     shape.delete();
        //     await context.sync();
        //   }
        // } else 
        if (shape.type == "Image") {
          options.imageLeft = shape.left;
          options.imageTop = shape.top;
          options.imageWidth = shape.width;
          options.imageHeight = shape.height;

          shape.delete();
          await context.sync();
        }
      }
    });
  } catch (error) {
    console.log("getSelectedImageOptions");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return options;
}

// 获取当前选中单页Slide内容
export async function getSlideText(includeContent = false) {
  PowerPoint = window.PowerPoint
  let allSlideText = "";
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      // 获取当前幻灯片的信息
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shape.type == "GeometricShape") {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load(
            "hasText, topMargin, leftMargin, rightMargin, bottomMargin, verticalAlignment, wordWrap"
          );
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            if (shape.name.startsWith("Title")) {
              allSlideText += textRange.text;
              allSlideText += "\n";
            } else if (
              shape.name.startsWith("Content Placeholder") &&
              includeContent
            ) {
              allSlideText += textRange.text;
              allSlideText += "\n";
            }
          }
        }
      }
    });
  } catch (error) {
    console.log("getSlideText: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return allSlideText;
}

export async function getCurSlidePageNumber() {
  PowerPoint = window.PowerPoint
  let selectedSlidePageNumber = 0;
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      // 获取当前幻灯片页码
      context.presentation.load("slides");
      await context.sync();
      context.presentation.slides.load("items");
      await context.sync();
      for (
        let index = 0;
        index < context.presentation.slides.items.length - 1;
        index++
      ) {
        let slide = context.presentation.slides.items[index];
        if (slide.id === selectedSlide.id) {
          selectedSlidePageNumber = index + 1;
          break;
        }
      }
    });
  } catch (error) {
    console.log("getCurSlidePageNumber: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return selectedSlidePageNumber;
}

export async function getSlideTextWithName(shapeName) {
  PowerPoint = window.PowerPoint
  let contentText = "";
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shape.type == "GeometricShape" && shape.name.startsWith(shapeName)) {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load(
            "hasText, topMargin, leftMargin, rightMargin, bottomMargin, verticalAlignment, wordWrap"
          );
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            contentText += textRange.text;
            break;
          }
        }
      }
    });
  } catch (error) {
    console.log("getSlideTextWithName");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return contentText;
}

export async function updateSlideTextWithName(shapeName, contentData) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        if (shape.type == "GeometricShape" && shape.name.startsWith(shapeName)) {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load(
            "hasText, topMargin, leftMargin, rightMargin, bottomMargin, verticalAlignment, wordWrap"
          );
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            textRange.text = contentData;
            await context.sync();
            break;
          }
        }
      }
    });
  } catch (error) {
    console.log("updateSlideTextWithName");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

export function getOnePageTemplateById(templateId) {
  let templateLib = store.get("gpt/template_onepage_libraries");
  let templateRet = null;
  for (let i = 0; i < templateLib.length; i++) {
    let template = templateLib[i];
    if (template.id == templateId) {
      templateRet = template;
      break;
    }
  }
  return templateRet;
}

// gen currentSelectedSlide index
export async function getCurrentSlidePageIndex(Success, Failed) {
  let currentSlidePageIndex = 0;
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides()
      selectedSlides.load("items")
      await context.sync()
      let currentSlide = null
      let currentSlideId = null
      if (selectedSlides.items.length > 0) {
        currentSlide = selectedSlides.items[0]
      }
      if (currentSlide) {
        currentSlide.load("id");
        await context.sync();
        currentSlideId = currentSlide.id;
      }

      if (currentSlideId) {
        let allSlides = context.presentation.slides;
        allSlides.load("items");
        await context.sync();
        for (let j = 0; j < allSlides.items.length; j++) {
          let slide = allSlides.items[j];
          slide.load("id");
          await context.sync();
          if (slide.id === currentSlideId) {
            currentSlidePageIndex = j + 1;
            break;
          }
        }
      }
    });
  } catch (error) {
    console.log("getCurrentSlidePageIndex");
    if (typeof Failed === "function") {
      Failed("Error get slide pageindex error.");
    }
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }

  if (typeof Success === "function") {
    Success(currentSlidePageIndex);
  }
  return currentSlidePageIndex;
}

// 获取当前演示文稿所有内容
export async function getAllSlideText(onSuccess, onFailed) {
  let allSlideText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.slides;
      selectedSlides.load("items");
      await context.sync();

      for (let j = 0; j < selectedSlides.items.length; j++) {
        let selectedSlide = selectedSlides.items[j];
        // 获取当前幻灯片的信息
        selectedSlide.load("shapes");
        await context.sync();
        let shapeCollection = selectedSlide.shapes;
        shapeCollection.load("items");
        await context.sync();
        let shapes = shapeCollection.items;

        const pageNumber = j + 1
        allSlideText += "page " + pageNumber + " :" + "\n"

        for (let i = 0; i < shapes.length; i++) {
          // 一个Shape的JSON数据
          let shape = shapes[i];
          shape.load("$all");
          await context.sync();

          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            textFrame.load("hasText");
            await context.sync();
            if (textFrame.hasText) {
              // text range
              textFrame.load("textRange");
              await context.sync();
              let textRange = textFrame.textRange;
              textRange.load("$all");
              await context.sync();
              allSlideText += textRange.text;
              allSlideText += "\n";
            }
          } else if (shape.type == "Group") {
            // todo
          } else if (shape.type == "Image") {
            // todo
          } else if (shape.type == "Table") {
            // todo
          } else if (shape.type == "Unsupported") {
            // todo
          } else {
            // todo
          }
        }
      }
    });

    if (typeof onSuccess === "function") {
      onSuccess(allSlideText);
    }
  } catch (error) {
    console.log("getAllSlideText: ", error);
    if (typeof onFailed === "function") {
      onFailed("GetAllSlideText Error.");
    }
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return allSlideText;
}

/**
 * show dialog, test dialog function
 */
export function showDialog() {
  Office.context.ui.displayDialogAsync('/igpt',
    { height: 50, width: 50 },
    function (asyncResult) {
      var dialog = asyncResult.value;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, function (args) {
        dialog.close();
      });
    });
}

/**
 * updata all slides data after translate
 */
export async function updateAllSlideDatafromJSONData(allSlideJSONDataString) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let allSlides = context.presentation.slides
      allSlides.load('items')
      await context.sync()
      let allSlideJSONData = []
      try {
        allSlideJSONData = JSON.parse(allSlideJSONDataString)
      } catch (error) {
        publish(gptPubIds.pubId_Local_PPT_init_error, error)
      }
      for (let index = 0; index < Math.min(allSlides.items.length, wdConfigData.maxTranslatePages); index++) {
        const element = allSlides.items[index]
        const elementJSONData = allSlideJSONData.find(item => item.PI === index)
        const shapeJSONData = elementJSONData ? elementJSONData.PC : []

        element.load('shapes')
        await context.sync()
        const shapeCollections = element.shapes
        shapeCollections.load('items')
        await context.sync()
        let elementShaps = shapeCollections.items
        if (elementShaps.length > 0 && shapeJSONData.length > 0) {
          for (let i = 0; i < shapeJSONData.length; i++) {
            shapeJSONData[i].U = false
          }
          for (let shapeIndex = 0; shapeIndex < elementShaps.length; shapeIndex++) {
            const shape = elementShaps[shapeIndex]
            shape.load('$all')
            await context.sync()
            // 按照模板结构，如果模板结构中存在没有说明的shape,则直接忽略
            let text = null
            if (shapeIsTextType(shape.type, shape.name)) {
              let textFrame = shape.textFrame;
              textFrame.load("hasText")
              await context.sync()
              if (textFrame.hasText) {
                textFrame.load("textRange")
                await context.sync()
                let textRange = textFrame.textRange
                textRange.load("$all")
                await context.sync()
                text = textRange.text
              }
            }
            // let shapeData = shapeJSONData.find(item => item.ST === shape.type && item.SN === shape.name)
            let shapeData = null
            if (text) {
              for (let j = 0; j < shapeJSONData.length; j++) {
                if (shapeJSONData[j].ST === shape.type && shapeJSONData[j].SN === shape.name && !shapeJSONData[j].U) {
                  shapeData = shapeJSONData[j]
                  shapeJSONData[j].U = true
                  break
                }
              }
            }
            if (shapeData && !shapeData.SN.includes('动作按钮') && shapeIsTextType(shape.type, shape.name)) {
              let textFrame = shape.textFrame;
              textFrame.load("hasText")
              await context.sync()
              if (textFrame.hasText) {
                textFrame.load("textRange", 'autoSizeSetting')
                await context.sync()
                textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape
                let textRange = textFrame.textRange
                textRange.load("$all")
                await context.sync()
                textRange.text = shapeData ? shapeData.TSC : ''
                await context.sync()
              }
            }
          }
        }
      }
    })
  } catch (error) {
    console.log("updateAllSlideDatafromJSONData:: " + error);
    // publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}


// 获取当前演示文稿所有内容，结构化内容，为了翻译和翻译之后使用方便
export async function getAllSlideJsonText(Success, Failed) {
  let allSlideText = "";
  let allContent = []
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.slides;
      selectedSlides.load("items");
      await context.sync();

      for (let j = 0; j < selectedSlides.items.length; j++) {
        let selectedSlide = selectedSlides.items[j];
        // 获取当前幻灯片的信息
        selectedSlide.load("shapes");
        await context.sync();
        let shapeCollection = selectedSlide.shapes;
        shapeCollection.load("items");
        await context.sync();
        let shapes = shapeCollection.items;

        const pageNumber = j
        let pageContent = {
          PI: pageNumber,
          PC: []
        }
        // allSlideText += "page " + pageNumber + " :" + "\n"

        for (let i = 0; i < shapes.length; i++) {
          let shapeContent = {
            ST: "",
            SN: "",
            SC: ""
          }
          // 一个Shape的JSON数据
          let shape = shapes[i];
          shape.load("$all");
          await context.sync();
          shapeContent.ST = shape.type
          shapeContent.SN = shape.name
          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            textFrame.load("hasText");
            await context.sync();
            if (textFrame.hasText) {
              // text range
              textFrame.load("textRange");
              await context.sync();
              let textRange = textFrame.textRange;
              textRange.load("$all");
              await context.sync();
              // allSlideText += textRange.text;
              // allSlideText += "\n";
              shapeContent.SC = textRange.text
            }
          } else if (shape.type == "Group") {
            // todo
            shapeContent.SC = ''
          } else if (shape.type == "Image") {
            // todo
            shapeContent.SC = ''
          } else if (shape.type == "Table") {
            // todo
            shapeContent.SC = ''
          } else if (shape.type == "Unsupported") {
            // todo
            shapeContent.SC = ''
          } else {
            // todo
            shapeContent.SC = ''
          }
          pageContent.PC.push(shapeContent)
        }
        allContent.push(pageContent)
      }
    });

    if (typeof Success === "function") {
      Success(JSON.stringify(allContent));
    }
  } catch (error) {
    console.log("getAllSlideJsonText: ", error);
    if (typeof Failed === "function") {
      Failed("Error reading file properties.");
    }
  }
  return JSON.stringify(allContent);
}


// 获取当前选中单页Slide内容
export async function getSelectedFirstSlideText(Success) {
  let allSlideText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      // get the all shapes of the slide
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;

      for (let i = 0; i < shapes.length; i++) {
        // get the text contents of every shape
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();

        try {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load(
            "hasText, topMargin, leftMargin, rightMargin, bottomMargin, verticalAlignment, wordWrap"
          );
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;
            textRange.load("$all");
            await context.sync();
            allSlideText += textRange.text;
            allSlideText += "\n";
          }
        } catch (error) {
          console.log("!!getSelectedFirstSlideText: ", error + '!!getSelectedFirstSlideText error pageIndex: ' + i);
        }
      }
    });
  } catch (error) {
    console.log("getSelectedFirstSlideText: ", error);
  }
  if (typeof Success === "function") {
    Success(allSlideText);
  }
  return allSlideText;
}

//获取选中单个元素的文本
export async function getSelectTextRange(Success, Failed) {
  let allSelectedText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let slides = context.presentation.slides;
      slides.load("items");
      await context.sync();

      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items");
      await context.sync();
      const selectShapeCount = selectedShapes.items.length
      if (selectShapeCount == 0) {
        // todo 未选中任何区域
      } else if (selectShapeCount == 1) {
        // todo 选中一个
        let shape = selectedShapes.items[0]
        shape.load("$all");
        await context.sync();

        if (shapeIsTextType(shape.type, shape.name)) {
          // shape text frame
          let textFrame = shape.textFrame;
          textFrame.load("hasText");
          await context.sync();
          if (textFrame.hasText) {
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;

            textRange.load("text");
            await context.sync();

            allSelectedText += textRange.text;
            allSelectedText += "\n";
            // if (shape.name.startsWith("Title") || shape.name.startsWith("Text")) {
            //   allSlideText += textRange.text;
            //   allSlideText += "\n";
            // } else if (
            //   shape.name.startsWith("Content Placeholder")
            // ) {
            //   allSlideText += textRange.text;
            //   allSlideText += "\n";
            // }
          }
        } else if (shape.type == "Group") {
          // todo
        } else if (shape.type == "Image") {
          // todo
        } else if (shape.type == "Table") {
          // todo
        } else if (shape.type == "Unsupported") {
          // todo
        } else {
          // todo
        }
      } else {
        // todo 选中不止一个
      }
    });
  } catch (error) {
    console.log("getSelectTextRange: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }

  if (typeof Success === "function") {
    Success(allSelectedText);
  }
  if (typeof Failed === "function") {
    Failed("Error reading file properties.");
  }
  return allSelectedText;
}

// 选中单个文本元素，更新文本, 调整为新的默认样式
export async function optimizeSelectContent(content) {
  // let allSelectedText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items");
      await context.sync();
      const selectShapeCount = selectedShapes.items.length
      if (selectShapeCount == 0) {
        // todo 未选中任何区域
      } else if (selectShapeCount == 1) {
        // todo 选中一个
        selectedShapes.items.map(async (shape) => {
          shape.load("$all");
          await context.sync();
          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            textFrame.load("hasText");
            await context.sync();
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;

            textRange.load("autoSizeSetting")
            await context.sync()
            textRange.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeMixed
            await context.sync()

            textRange.load("font", "text", "size", "italic", "color", "bold")
            await context.sync()
            // 新的内容
            textRange.text = content
            await context.sync()

            // 尝试调试设置一个文本框中指定范围内文字的属性
            // if (textRange.text.length < 10) {
            //   console.warn("You must select only one shape with at least 10 characters in it.");
            // } else {
            //   // 设置选中范围
            //   const textRange10 = textRange.getSubstring(20, 10);
            //   textRange10.setSelected();
            //   await context.sync();
              
            //   textRange10.load("font", 'paragraphFormat')
            //   await context.sync()

            //   let paragraphFormat = textRange10.paragraphFormat
            //   paragraphFormat.load("bulletFormat")
            //   await context.sync()
            //   // 设置段落格式
            //   let bulletFormat = paragraphFormat.bulletFormat
            //   await context.sync()
            //   bulletFormat.load("visible")
            //   await context.sync()
            //   // 设置段落格式 
            //   bulletFormat.visible = true
            //   await context.sync()

            //   let textRangeTextFont = textRange10.font
            //   textRangeTextFont.load("size", "italic", "color", "bold")
            //   await context.sync()
            //   // 设置大小、斜体、颜色、加粗
            //   textRangeTextFont.size = 18
            //   textRangeTextFont.italic = false
            //   textRangeTextFont.color = "blue"
            //   textRangeTextFont.bold = true
            //   await context.sync();
              
            //   // 设置选中范围
            //   const textRange0 = textRange.getSubstring(0, 0);
            //   textRange0.setSelected();
            //   await context.sync();
            // }

            // var textRangeTextFont = textRange.font
            // 设置大小、斜体、颜色、加粗
            // textRangeTextFont.size = 14
            // textRangeTextFont.italic = false
            // textRangeTextFont.color = "blue"
            // textRangeTextFont.bold = false
            await context.sync()
          } else if (shape.type == "Group") {
            // todo
          } else if (shape.type == "Image") {
            // todo
          } else if (shape.type == "Table") {
            // todo
          } else if (shape.type == "Unsupported") {
            // todo
          } else {
            // todo
          }
        });
      } else {
        // todo 选中不止一个
      }
    });
  } catch (error) {
    console.log("optimizeSelectContent: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 选中单个文本元素，更新文本, 保持原本样式不变
export async function translateSelectContent(content) {
  // let allSelectedText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items");
      await context.sync();
      const selectShapeCount = selectedShapes.items.length
      if (selectShapeCount == 0) {
        // todo 未选中任何区域
      } else if (selectShapeCount == 1) {
        // todo 选中一个
        selectedShapes.items.map(async (shape) => {
          shape.load("$all");
          await context.sync();
          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            textFrame.load("hasText");
            await context.sync();
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;

            textRange.load("autoSizeSetting")
            await context.sync()
            textRange.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeMixed
            await context.sync()

            textRange.load("text")
            await context.sync()
            // 新的内容
            textRange.text = content
            await context.sync()
          } else if (shape.type == "Group") {
            // todo
          } else if (shape.type == "Image") {
            // todo
          } else if (shape.type == "Table") {
            // todo
          } else if (shape.type == "Unsupported") {
            // todo
          } else {
            // todo
          }
        });
      } else {
        // todo 选中不止一个
      }
    });
  } catch (error) {
    console.log("optimizeSelectContent", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}


// 选中单个文本元素，补充文本
export async function addContentforSelectShape(content) {
  // let allSelectedText = "";
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items");
      await context.sync();
      const selectShapeCount = selectedShapes.items.length
      if (selectShapeCount == 0) {
        // todo 未选中任何区域
      } else if (selectShapeCount == 1) {
        // todo 选中一个
        selectedShapes.items.map(async (shape) => {
          shape.load("$all");
          await context.sync();
          if (shapeIsTextType(shape.type, shape.name)) {
            // shape text frame
            let textFrame = shape.textFrame;
            textFrame.load("hasText");
            await context.sync();
            // text range
            textFrame.load("textRange");
            await context.sync();
            let textRange = textFrame.textRange;

            textRange.load("autoSizeSetting")
            await context.sync()
            textRange.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeMixed
            await context.sync()

            textRange.load("font", "text", "size", "italic", "color", "bold")
            await context.sync()
            // 新的内容
            textRange.text += content
            await context.sync()
          } else if (shape.type == "Group") {
            // todo
          } else if (shape.type == "Image") {
            // todo
          } else if (shape.type == "Table") {
            // todo
          } else if (shape.type == "Unsupported") {
            // todo
          } else {
            // todo
          }
        });
      } else {
        // todo 选中不止一个
      }
    });
  } catch (error) {
    console.log("addContentforSelectShape", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 插入标题元素
export async function insertTilteShape(content) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync()
      let slide = selectedSlides.items[0]
      slide.load("shapes")
      await context.sync()
      const shapes = slide.shapes
      let titleShape = shapes.addTextBox(content)
      await context.sync()
      titleShape.load("height", "left", "top", "width")
      await context.sync()
      titleShape.height = 88.9266929133858
      titleShape.left = 66
      titleShape.top = 28.75
      titleShape.width = 828
      await context.sync()

      titleShape.load("$all");
      await context.sync();
      let textFrame = titleShape.textFrame;
      // text range
      textFrame.load("textRange");
      await context.sync();
      let textRange = textFrame.textRange;

      textRange.load("font", "size", "italic", "color", "bold")
      await context.sync()

      var textRangeTextFont = textRange.font
      // 设置大小、斜体、颜色、粗细等
      textRangeTextFont.size = 44
      textRangeTextFont.italic = false
      // textRangeTextFont.color = "green"
      textRangeTextFont.bold = true
      await context.sync()
    });
  } catch (error) {
    console.log("insertTilteShape", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 插入文本元素
export async function insertTextShape(content) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync()
      let slide = selectedSlides.items[0]
      slide.load("shapes")
      await context.sync()
      const shapes = slide.shapes
      const alreadyHasText = await currentSlideContentSahpeType()
      let titleShape = shapes.addTextBox(content.replace(/#/g, ''))
      await context.sync()
      titleShape.load("height", "left", "top", "width")
      await context.sync()
      if (alreadyHasText.Text.count == 0) {
        titleShape.height = 380
        titleShape.left = 50
        titleShape.top = 150
        titleShape.width = 800
      } else {
        titleShape.height = 340
        titleShape.left = 450
        titleShape.top = 150
        titleShape.width = 500
      }
      await context.sync()

      titleShape.load("$all");
      await context.sync();
      let textFrame = titleShape.textFrame;
      // text range
      textFrame.load("textRange");
      await context.sync();
      let textRange = textFrame.textRange;

      // autoSizeSetting
      // textFrame.load("autoSizeSetting")
      // await context.sync()
      // let autoSizeSetting = textFrame.autoSizeSetting
      // autoSizeSetting = "AutoSizeShapeToFitText"
      // await context.sync()

      textRange.load("paragraphFormat")
      await context.sync()
      let paragraphFormat = textRange.paragraphFormat

      paragraphFormat.load("bulletFormat")
      await context.sync()
      let bulletFormat = paragraphFormat.bulletFormat

      bulletFormat.load("visible")
      await context.sync()
      bulletFormat.visible = false
      await context.sync()


      textRange.load("font", "size", "italic", "color", "bold")
      await context.sync()

      var textRangeTextFont = textRange.font
      // 设置大小、斜体、颜色、粗细等
      textRangeTextFont.size = 16
      textRangeTextFont.italic = false
      // textRangeTextFont.color = "green"
      textRangeTextFont.bold = false

      await context.sync()
    });
  } catch (error) {
    console.log("insertTextShape: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// 根据标题插入内容
export async function insertContentByTitle(content) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync()
      let slide = selectedSlides.items[0]
      slide.load("shapes")
      await context.sync()
      const shapes = slide.shapes
      // const alreadyHasText = await currentSlideContentSahpeType()
      // const existingShapes = await getAllShapePositionRects();
      let contentShape = shapes.addTextBox(content.replace(/#/g, ''))
      await context.sync()
      contentShape.load("height", "left", "top", "width")
      await context.sync()
      // if (alreadyHasText.Text.count == 0) {
      //   contentShape.height = 380
      //   contentShape.left = 50
      //   contentShape.top = 150
      //   contentShape.width = 800
      // } else {
      //   contentShape.height = 340
      //   contentShape.left = 450
      //   contentShape.top = 150
      //   contentShape.width = 500
      // }
      
      // placeShape(existingShapes).then((newShapePosition) => {
      //   if (newShapePosition) {
      //     console.log("new shape position:", newShapePosition);
      //     contentShape.height = newShapePosition.height
      //     contentShape.left = newShapePosition.left
      //     contentShape.top = newShapePosition.top
      //     contentShape.width = newShapePosition.width
      //   } else {
      //     console.log("No space available for the new shape.");
          contentShape.height = 260
          contentShape.left = 30
          contentShape.top = 180
          contentShape.width = 530
      //   }
      // })
      
      await context.sync()

      contentShape.load("$all");
      await context.sync();
      let textFrame = contentShape.textFrame;
      
      // autoSizeSetting
      textFrame.load("autoSizeSetting")
      await context.sync()
      let autoSizeSetting = textFrame.autoSizeSetting
      // autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeNone
      // autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeMixed
      autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeShapeToFitText
      // autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape
      await context.sync()

      // text range
      textFrame.load("textRange");
      await context.sync();
      let textRange = textFrame.textRange;


      textRange.load("paragraphFormat")
      await context.sync()
      let paragraphFormat = textRange.paragraphFormat

      paragraphFormat.load("bulletFormat")
      await context.sync()
      let bulletFormat = paragraphFormat.bulletFormat

      bulletFormat.load("visible")
      await context.sync()
      bulletFormat.visible = false
      await context.sync()


      textRange.load("font", "size", "italic", "color", "bold")
      await context.sync()

      var textRangeTextFont = textRange.font
      // 设置大小、斜体、颜色、粗细等
      textRangeTextFont.size = 18
      textRangeTextFont.italic = false
      // textRangeTextFont.color = "green"
      textRangeTextFont.bold = false

      await context.sync()
    });
  } catch (error) {
    console.log("insertTextShape: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}

// all shapes position
async function getAllShapePositionRects() {
  let allSahpeRects = [];
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {

      let selectedSlides = context.presentation.getSelectedSlides()
      selectedSlides.load("items")
      await context.sync()
      let currentSlide = null
      if (selectedSlides.items.length > 0) {
        currentSlide = selectedSlides.items[0]
      }

      currentSlide.load("shapes");
      await context.sync();
      let shapeCollection = currentSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;
      // console.log("shapes count: " + shapes.length)

      for (let i = 0; i < shapes.length; i++) {
        let shape = shapes[i];
        // console.log('shape type: ' + shape.type + " || shape name: " + shape.name)
        shape.load("height", "left", "top", "width")
        await context.sync()
        // console.log('shape: ')
        // console.log('** height ' + shape.height)
        // console.log('** left ' + shape.left)
        // console.log('** top ' + shape.top)
        // console.log('** width ' + shape.width)

        let shapeRect = new Rect(shape.top, shape.left, shape.height, shape.width)
        allSahpeRects.push(shapeRect)
      }
    });
  } catch (error) {
    console.log("getAllSahpeRects: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  return allSahpeRects;
}

// 整合多个文本元素
export async function integrateTextShape(messageContent) {
  PowerPoint = window.PowerPoint
  getMlutiTextShapeText(async (selectMlutiShapeProperty) => {
    try {
      await PowerPoint.run(async function (context) {
        let selectedSlides = context.presentation.getSelectedSlides();
        selectedSlides.load("items");
        await context.sync();
        let selectedSlide = selectedSlides.items[0];
        selectedSlide.load("shapes");
        await context.sync();

        const shapes = selectedSlide.shapes
        let titleShape = shapes.addTextBox(messageContent)
        await context.sync()
        titleShape.load("height", "left", "top", "width")
        await context.sync()
        titleShape.height = selectMlutiShapeProperty.firstShapePosition.height
        titleShape.left = selectMlutiShapeProperty.firstShapePosition.left
        titleShape.top = selectMlutiShapeProperty.firstShapePosition.top
        titleShape.width = selectMlutiShapeProperty.firstShapePosition.width
        await context.sync()

        titleShape.load("$all");
        await context.sync();
        let textFrame = titleShape.textFrame;
        // text range
        textFrame.load("textRange", 'autoSizeSetting');
        await context.sync();
        textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape
        let textRange = textFrame.textRange;

        textRange.load("font", 'name', "size", "italic", "color", "bold")
        await context.sync()

        var textRangeTextFont = textRange.font

        textRangeTextFont.name = selectMlutiShapeProperty.firstShapeFont.name
        textRangeTextFont.size = selectMlutiShapeProperty.firstShapeFont.size === 0 ? 14 : selectMlutiShapeProperty.firstShapeFont.size
        textRangeTextFont.italic = selectMlutiShapeProperty.firstShapeFont.italic
        textRangeTextFont.color = selectMlutiShapeProperty.firstShapeFont.color
        textRangeTextFont.bold = selectMlutiShapeProperty.firstShapeFont.bold

        await context.sync()
      });
    } catch (error) {
      console.log("integrateTextShape: ", error);
      publish(gptPubIds.pubId_Local_PPT_init_error, error);
    }
  })
}


// 拿到多个文本元素内容，不需要删除当前选中shape
export async function getMlutiTextShapeContent(Success, Failed) {
  PowerPoint = window.PowerPoint
  let selectMlutiShapeProperty = {
    selectShapesText: "",
    firstShapePosition: {
      height: 410.4,
      left: 42.24,
      top: 95.76,
      width: 463.2
    }
  }
  try {
    await PowerPoint.run(async function (context) {
      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items")
      await context.sync()

      for (let i = 0; i < selectedShapes.items.length; i++) {
        const shape = selectedShapes.items[i]
        shape.load("$all")
        await context.sync()
        if (shapeIsTextType(shape.type, shape.name)) {
          // shape text frame
          let textFrame = shape.textFrame
          textFrame.load("textRange")
          await context.sync()
          let textRange = textFrame.textRange
          await context.sync()

          textRange.load("text")
          await context.sync()
          selectMlutiShapeProperty.selectShapesText += textRange.text
          selectMlutiShapeProperty.selectShapesText += "\n"

          // if (i == 0) {
          //   shape.load("height", "left", "top", "width")
          //   await context.sync()
          //   selectMlutiShapeProperty.firstShapePosition.height = shape.height
          //   selectMlutiShapeProperty.firstShapePosition.left = shape.left
          //   selectMlutiShapeProperty.firstShapePosition.top = shape.top
          //   selectMlutiShapeProperty.firstShapePosition.width = shape.width
          // }
        } else if (shape.type == "Group") {
          // todo
        } else if (shape.type == "Image") {
          // todo
        } else if (shape.type == "Table") {
          // todo
        } else if (shape.type == "Unsupported") {
          // todo
        } else {
          // todo
        }
      }
    });
  } catch (error) {
    console.log("getMlutiTextShapeContent: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }

  if (typeof Success === "function") {
    Success(selectMlutiShapeProperty);
  }
  if (typeof Failed === "function") {
    Failed("Error reading file properties.");
  }
  return selectMlutiShapeProperty;
}

// 拿到多个文本元素内容，同时删除当前选中shape
export async function getMlutiTextShapeText(Success, Failed) {
  PowerPoint = window.PowerPoint
  let selectMlutiShapeProperty = {
    selectShapesText: "",
    firstShapePosition: {
      height: "410.4",
      left: "42.24",
      top: "95.76",
      width: "463.2"
    },
    firstShapeFont: {
      name: 'Microsoft YaHei UI',
      size: 16,
      color: 'black',
      italic: false,
      bold: false
    }
  }
  try {
    await PowerPoint.run(async function (context) {
      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items")
      await context.sync()

      for (let i = 0; i < selectedShapes.items.length; i++) {
        const shape = selectedShapes.items[i]
        shape.load("$all")
        await context.sync()
        if (shapeIsTextType(shape.type, shape.name)) {
          // shape text frame
          let textFrame = shape.textFrame
          textFrame.load("textRange")
          await context.sync()
          let textRange = textFrame.textRange
          await context.sync()

          textRange.load("text")
          await context.sync()
          selectMlutiShapeProperty.selectShapesText += textRange.text
          selectMlutiShapeProperty.selectShapesText += "\n"

          if (i == 0) {
            shape.load("height", "left", "top", "width")
            await context.sync()
            selectMlutiShapeProperty.firstShapePosition.height = shape.height
            selectMlutiShapeProperty.firstShapePosition.left = shape.left
            selectMlutiShapeProperty.firstShapePosition.top = shape.top
            selectMlutiShapeProperty.firstShapePosition.width = shape.width

            textRange.load("font")
            await context.sync()
            const firstShapeFont = textRange.font
            firstShapeFont.load("name", "size", "color", "italic", "bold")
            await context.sync()
            selectMlutiShapeProperty.firstShapeFont.name = firstShapeFont.name
            selectMlutiShapeProperty.firstShapeFont.size = firstShapeFont.size
            selectMlutiShapeProperty.firstShapeFont.color = firstShapeFont.color
            selectMlutiShapeProperty.firstShapeFont.italic = firstShapeFont.italic
            selectMlutiShapeProperty.firstShapeFont.bold = firstShapeFont.bold
          }
        } else if (shape.type == "Group") {
          // todo
        } else if (shape.type == "Image") {
          // todo
        } else if (shape.type == "Table") {
          // todo
        } else if (shape.type == "Unsupported") {
          // todo
        } else {
          // todo
        }
      }

      for (let i = 0; i < selectedShapes.items.length; i++) {
        const shape = selectedShapes.items[i]
        shape.delete()
        await context.sync()
      }
    });
  } catch (error) {
    console.log("getMlutiTextShapeText: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }

  if (typeof Success === "function") {
    Success(selectMlutiShapeProperty);
  }
  if (typeof Failed === "function") {
    Failed("Error reading file properties.");
  }
  return selectMlutiShapeProperty;
}

// Get the selected text, there are several possibilities.
export async function getSelectedShapeText(Success) {
  let selectContent = ""
  PowerPoint = window.PowerPoint
  // bodong: Checking the API version, because some versions of Office do not support the latest PowerPoint API version.
  // if (Office.context.requirements.isSetSupported('PowerPointApi', '1.6')) {
  //   console.log('isSetSupported: PowerPointApi 1.6 ' + true);
  // } else {
  //   console.log('isSetSupported: PowerPointApi 1.6 ' + false);
  // }
  try {
    await PowerPoint.run(async function (context) {
      // let selectedSlides = context.presentation.getSelectedSlides();
      // selectedSlides.load("items");
      // await context.sync();
      // if (selectedSlides.items.length == 0) {
      //   // selected no slide 
      // } else if (selectedSlides.items.length == 1) {
      //   // selected one slide
      //   selectContent = await getSelectedFirstSlideText()
      // } else {
      //   // selected more slides
      //   selectContent = await getSelectedFirstSlideText()
      // }

      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items")
      await context.sync()
      if (selectedShapes.items.length == 0) {
        // not selected shape
      } else if (selectedShapes.items.length == 1) {
        // selected one shape
        let currentSelectStatus = await getCurrentSelectState()
        if (currentSelectStatus.selectShape.shapeType.find(item => item == "Image") != null) {
          // notes: The selected shape contains an image, and the selected content is the entire slide content
          selectContent = await getSelectedFirstSlideText()
        } else {
          await getSelectTextRange((selectOneTextShapeContent) => {
            selectContent = selectOneTextShapeContent
          })
        }
      } else {
        // selected more shapes
        await getMlutiTextShapeContent((selectMlutiShapeProperty) => {
          selectContent = selectMlutiShapeProperty.selectShapesText
        })
      }
    });
  } catch (error) {
    console.log("getCurrentSelectContent: ", error);
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
  if (typeof Success === "function") {
    Success(selectContent);
  }
  return selectContent;
}


// 获取当前选中状态
export async function getCurrentSelectState(onSuccess, onFailed) {
  PowerPoint = window.PowerPoint
  let selectState = {
    selectSlide: {
      count: 0,
      state: ""
    },
    selectShape: {
      count: 0,
      state: "",
      shapeType: []
    },
    selectOneShape: {
      count: 0,
      state: ""
    },
    selectMlutiShape: {
      count: 0,
      state: ""
    }
  }
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      selectState.selectSlide.count = selectedSlides.items.length
      if (selectedSlides.items.length == 0) {
        // 没有选中任何slide
        selectState.selectSlide.state = i18n.t("ppt_select_state.select_no_slide")
      } else if (selectedSlides.items.length == 1) {
        // 选中单个slide
        selectState.selectSlide.state = i18n.t("ppt_select_state.select_one_slide")
      } else {
        // 选中多个slide
        selectState.selectSlide.state = i18n.t("ppt_select_state.select_mluti_slide")
      }

      let selectedShapes = context.presentation.getSelectedShapes()
      selectedShapes.load("items")
      await context.sync()
      selectState.selectShape.count = selectedShapes.items.length
      if (selectedShapes.items.length == 0) {
        // 没有选中任何shape
        selectState.selectShape.state = i18n.t("ppt_select_state.select_no_shape")
        let selectedShape = await currentSlideContentSahpeType()
        selectState.selectShape.shapeType = []
        if (selectedShape && selectedShape.Image.count > 0) {
          selectState.selectShape.shapeType.push("Image")
        }
      } else if (selectedShapes.items.length == 1) {
        // 选中单个shape
        selectState.selectShape.state = i18n.t("ppt_select_state.select_one_shape")
        selectState.selectOneShape.state = i18n.t("ppt_select_state.select_one_shape")

        let shapes = selectedShapes.items
        let shape = shapes[0]
        shape.load("fill")
        await context.sync()
        let fill = shape.fill
        fill.load('foregroundColor')
        await context.sync()
        // fill.foregroundColor = '#FFFFFF'

        // shape.load("height", "left", "top", "width")
        // await context.sync()
        // console.log('shape: ')
        // console.log('** height ' + shape.height)
        // console.log('** left ' + shape.left)
        // console.log('** top ' + shape.top)
        // console.log('** width ' + shape.width)
        // await context.sync()

        // shape.load("$all")
        // await context.sync()
        // let textFrame = shape.textFrame
        // textFrame.load("textRange")
        // await context.sync()
        // let textRange = textFrame.textRange

        // textRange.load("font", "size", "italic", "color", "bold", "underline", 'start', 'paragraphFormat')
        // await context.sync()
        // var textRangeTextFont = textRange.font
        // await context.sync()

        switch (shape.type) {
          case "Placeholder":
            if (placeHolderShapeHasText(shape.name)) {
              let textFrame = shape.textFrame
              textFrame.load("hasText")
              await context.sync()
              if (textFrame.hasText) {
                selectState.selectShape.shapeType.push("Text")
              }
            } else {
              // 目前 placeholder type类型的shape只有内容/标题和图片这几种
              selectState.selectShape.shapeType.push("Image")
            }
            break;
          case "GeometricShape":
          case "TextBox":
            {
              let textFrame = shape.textFrame
              textFrame.load("hasText")
              await context.sync()
              if (textFrame.hasText) {
                selectState.selectShape.shapeType.push("Text")
              }
            }
            break;
          case "Group":
            selectState.selectShape.shapeType.push("Group")
            break;
          case "Image":
            selectState.selectShape.shapeType.push("Image")
            break;
          case "Line":
            selectState.selectShape.shapeType.push("Line")
            break;
          case "Table":
            selectState.selectShape.shapeType.push("Table")
            break;
          case "SmartArt":
            selectState.selectShape.shapeType.push("SmartArt")
            break;
          default:
            selectState.selectShape.shapeType.push(shape.type)
            break;
        }

        // let selectedShape = await currentSlideContentSahpeType()
        // selectState.selectShape.shapeType = []
        // if (selectedShape.Image.count > 0) {
        //   selectState.selectShape.shapeType.push("Image")
        // } else if (selectedShape.Text.count > 0) {
        //   selectState.selectShape.shapeType.push("Text")
        // }
      } else {
        // 选中多个shape
        selectState.selectShape.state = i18n.t("ppt_select_state.select_mluti_shapes")
        selectState.selectMlutiShape.state = i18n.t("ppt_select_state.select_mluti_shapes")

        let shapes = selectedShapes.items
        for (let i = 0; i < shapes.length; i++) {
          let shape = shapes[i]
          shape.load("$all")
          await context.sync()
          switch (shape.type) {
            case "Placeholder":
              if (placeHolderShapeHasText(shape.name)) {
                let textFrame = shape.textFrame
                textFrame.load("hasText")
                await context.sync()
                if (textFrame.hasText) {
                  selectState.selectShape.shapeType.push("Text")
                }
              } else {
                // 目前 placeholder type类型的shape只有内容/标题和图片这几种
                selectState.selectShape.shapeType.push("Image")
              }
              break;
            case "GeometricShape":
            case "TextBox":
              {
                let textFrame = shape.textFrame
                textFrame.load("hasText")
                await context.sync()
                if (textFrame.hasText) {
                  selectState.selectShape.shapeType.push("Text")
                }
              }
              break;
            case "Group":
              selectState.selectShape.shapeType.push("Group")
              break;
            case "Image":
              selectState.selectShape.shapeType.push("Image")
              break;
            case "Line":
              selectState.selectShape.shapeType.push("Line")
              break;
            case "Table":
              selectState.selectShape.shapeType.push("Table")
              break;
            case "SmartArt":
              selectState.selectShape.shapeType.push("SmartArt")
              break;
            default:
              selectState.selectShape.shapeType.push(shape.type)
              break;
          }
        }
      }
    });
  } catch (error) {
    console.log("getCurrentSelectState: " + error);
    // publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }

  if (typeof onSuccess === "function") {
    onSuccess(selectState);
  }
  if (typeof onFailed === "function") {
    onFailed("Error reading file properties.");
  }
  return selectState;
}


// 当前slide是否已经存在图片、文本框、标题元素
export async function currentSlideContentSahpeType() {
  PowerPoint = window.PowerPoint
  let contentSahpeTypenCount = {
    Text: {
      count: 0
    },
    Image: {
      count: 0
    },
    Table: {
      count: 0
    },
    Line: {
      count: 0
    },
    Group: {
      count: 0
    },
    OtherShape: {
      count: 0
    }
  }
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      if (selectedSlides.items.length > 0) {
        let slide = selectedSlides.items[0]
        slide.load("shapes")
        await context.sync()
        let shapeCollection = slide.shapes
        shapeCollection.load("items")
        await context.sync()
        let shapes = shapeCollection.items
        if (shapes.length > 0) {
          for (let i = 0; i < shapes.length; i++) {
            let shape = shapes[i]
            shape.load("$all")
            await context.sync()
            switch (shape.type) {
              case "Placeholder":
                if (placeHolderShapeHasText(shape.name)) {
                  let textFrame = shape.textFrame
                  textFrame.load("hasText")
                  await context.sync()
                  if (textFrame.hasText) {
                    contentSahpeTypenCount.Text.count++
                  }
                } else {
                  // 目前 placeholder type类型的shape只有内容/标题和图片这几种
                  contentSahpeTypenCount.Image.count++
                }
                break;
              case "GeometricShape":
              case "TextBox":
                {
                  let textFrame = shape.textFrame
                  textFrame.load("hasText")
                  await context.sync()
                  if (textFrame.hasText) {
                    contentSahpeTypenCount.Text.count++
                  }
                }
                break;
              case "Group":
                contentSahpeTypenCount.Group.count++
                break;
              case "Image":
                contentSahpeTypenCount.Image.count++
                break;
              case "Line":
                contentSahpeTypenCount.Line.count++
                break;
              case "Table":
                contentSahpeTypenCount.Table.count++
                break;
              default:
                contentSahpeTypenCount.OtherShape.count++
                break;
            }
          }
        } else {
          // 当前slide是空的
          console.log("当前slide是空的");
        }
      } else {
        // todo 请选择要操作的对象
        console.log("请选择要操作的对象");
      }
    });
    return contentSahpeTypenCount
  } catch (error) {
    console.log("currentSlideContentSahpeType: ", error);
    // publish(gptPubIds.pubId_Local_PPT_init_error, error)
    return null
  }
}

export async function insertImgandReplace(imageUrl) {
  let options;
  if (vstoMode) {
    let strOptions = await hostObject_shapes.vsto_getSlideImageOptionsThenDel();
    options = JSON.parse(strOptions);
  } else {
    options = await getSelectedImageOptions();
  }
  await insertImageByCompletionUrl(imageUrl, options);
}

export async function addProductLogandTxt() {
  /* left: 744.172204724409
  top: 503.212755905512
  height: 29.0812598425197
  width: 205.6
  size: 16
  color: #AFC798
  bold: false
  underline: Single */
  /* PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides()
      selectedSlides.load("items")
      await context.sync()
      let slides = selectedSlides.items

      // let slides = context.presentation.slides
      // slides.load("items");
      await context.sync();
      if (slides.length > 0) {
        let slide = slides[0]
        slide.load("shapes")
        await context.sync()
        const shapes = slide.shapes
        let titleShape = shapes.addTextBox("本PPT及插图由《演神》生成")
        await context.sync()
        titleShape.load("height", "left", "top", "width")
        await context.sync()
        titleShape.height = 20.6
        titleShape.left = 795.2
        titleShape.top = 517.848
        titleShape.width = 163.8
        await context.sync()
  
        titleShape.load("$all");
        await context.sync();
        let textFrame = titleShape.textFrame;
        textFrame.load("textRange");
        await context.sync();
        let textRange = textFrame.textRange;
  
        textRange.load("font", "size", "italic", "color", "bold", "underline")
        await context.sync()
        var textRangeTextFont = textRange.font
        textRangeTextFont.size = 11
        textRangeTextFont.italic = false
        textRangeTextFont.color = "#AFC798"
        textRangeTextFont.bold = false
        // textRangeTextFont.underline = 'Single'
        await context.sync()
      }
    });
  } catch (error) {
    console.log("addProductLogandTxt: " + error);
  } */
}

export async function UniformFont(fontType) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.slides
      selectedSlides.load("items")
      await context.sync()

      for (let j = 0; j < selectedSlides.items.length; j++) {
        publish(actionUniform.pubId_Action_Uniform_Font, { total: selectedSlides.items.length, current: j })
        let selectedSlide = selectedSlides.items[j]
        // Slide
        selectedSlide.load("shapes")
        await context.sync()
        let shapeCollection = selectedSlide.shapes
        shapeCollection.load("items")
        await context.sync()
        let shapes = shapeCollection.items
        for (let i = 0; i < shapes.length; i++) {
          // Shape
          let shape = shapes[i]
          shape.load("$all")
          await context.sync()
          try {
            if (shapeIsTextType(shape.type, shape.name)) {
              let textFrame = shape.textFrame
              await context.sync()
              textFrame.load("hasText")
              await context.sync()
              if (textFrame.hasText) {
                // text range
                textFrame.load("textRange")
                await context.sync()
                let textRange = textFrame.textRange
                textRange.load("font")
                // await context.sync()
                let font = textRange.font
                font.load('name')
                await context.sync()
                font.name = fontType
              }
            }
          } catch (error) {
            console.log('!!UniformFont shape error: ' , error);
            console.log('!!UniformFont shape error pageIndex: ', j);
            continue
          }
        }
      }
    });
  } catch (error) {
    console.log("UniformFont: ", error);
    publish(actionUniform.pubId_Action_Uniform_Font, { total: 0, current: 0 })
  }
}

export async function UniformShapeColor(shapeColor) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.slides
      selectedSlides.load("items")
      await context.sync()

      for (let j = 0; j < selectedSlides.items.length; j++) {
        publish(actionUniform.pubId_Action_Uniform_Color, { total: selectedSlides.items.length, current: j })
        let selectedSlide = selectedSlides.items[j]
        // Slide
        selectedSlide.load("shapes")
        await context.sync()
        let shapeCollection = selectedSlide.shapes
        shapeCollection.load("items")
        await context.sync()
        let shapes = shapeCollection.items

        for (let i = 0; i < shapes.length; i++) {
          try {
            // Shape
            let shape = shapes[i]
            shape.load("type", 'name')
            await context.sync()
            if (shape.type)
              shape.load("fill")
            await context.sync()
            let fill = shape.fill
            fill.load('foregroundColor')
            await context.sync()
            if (fill && fill.foregroundColor && fill.foregroundColor != '#FFFFFF') {
              fill.foregroundColor = shapeColor
            }
          } catch (error) {
            console.log('!!UniformColor shape error: ' , error);
            console.log('!!UniformColor shape error pageIndex: ', j);
            continue
          }
        }
      }
    });
  } catch (error) {
    console.log("UniformShapeColor: ", error);
    publish(actionUniform.pubId_Action_Uniform_Color, { total: 0, current: 0 })
  }
}

export function shapeIsTextType(shapeType, shapeName) {
  // const textShapeTypeArr = ['GeometricShape', 'Callout', 'Freeform', 'Placeholder', 'SmartArt', 'Table', 'TextBox' ]
  const textShapeTypeArr = ['GeometricShape', 'Placeholder', 'TextBox']
  if (shapeType == "Placeholder") {
    return placeHolderShapeHasText(shapeName)
  } else {
    return textShapeTypeArr.indexOf(shapeType) != -1
  }
}

// JS API升级导致，placeHolder类型出现不稳定，有一些type的TextFrame的属性中不包含hasText属性
export function placeHolderShapeHasText(shapeName) {
  // return !shapeName.includes('Picture') && !shapeName.includes('内容') && !shapeName.includes('图片')
  return !shapeName.includes('Picture') && !shapeName.includes('图片')
}

export function getSlidePreImg(slideFileName) {
  let templateUrl = ''
  if (JSON.parse(localStorage.getItem(userKeys.key_user_settings_select_template_is_semantic))) {
    templateUrl = `/layout/template_semantic/${slideFileName}.pptx`
  } else {
    templateUrl = `/layout/template_title_contents/${slideFileName}.pptx`
  }
  let slide = get_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`)
  PowerPoint = window.PowerPoint
  try {
    PowerPoint.run(async function (context) {
      let ImgOptions = {
        height: 2014,
        width: 2014,
      }
      // console.log('slide: ' + slide);

      let imgBase64 = slide.getImageAsBase64(ImgOptions)
      // console.log('imgBase64: ' + imgBase64);
    });
  } catch (error) {
    console.log("currentSlideContentSahpeType: " + error)
  }
}

// update slide content from slideJSONDataString
export async function updateSlideContentWithJSONData(slideJSONDataString) {
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let slideJSONData = []
      try {
        slideJSONData = JSON.parse(slideJSONDataString)
      } catch (error) {
        console.log('updateTemplateSlideDatafromJSONData', error)
      }

      let selectedSlides = context.presentation.getSelectedSlides()
      selectedSlides.load("items")
      await context.sync()
      let currentSlide = null
      if (selectedSlides.items.length > 0) {
        currentSlide = selectedSlides.items[0]
      }

      currentSlide.load('shapes')
      await context.sync()
      const shapeCollections = currentSlide.shapes
      shapeCollections.load('items')
      await context.sync()
      let elementShaps = shapeCollections.items
      if (elementShaps.length > 0 && slideJSONData.length > 0) {
        for (let i = 0; i < slideJSONData.length; i++) {
          slideJSONData[i].U = false
        }
        for (let shapeIndex = 0; shapeIndex < elementShaps.length; shapeIndex++) {
          const shape = elementShaps[shapeIndex]
          shape.load('$all')
          await context.sync()

          // 按照模板结构，如果模板结构中存在没有说明的shape,则直接忽略
          let text = null
          if (shapeIsTextType(shape.type, shape.name)) {
            let textFrame = shape.textFrame;
            textFrame.load("hasText")
            await context.sync()
            if (textFrame.hasText) {
              textFrame.load("textRange")
              await context.sync()
              let textRange = textFrame.textRange
              textRange.load("$all")
              await context.sync()
              text = textRange.text
            }
          }

          let shapeData = null
          if (text) {
            for (let j = 0; j < slideJSONData.length; j++) {
              if (slideJSONData[j].ST === shape.type && slideJSONData[j].SN === shape.name && !slideJSONData[j].U) {
                shapeData = slideJSONData[j]
                slideJSONData[j].U = true
                break
              }
            }
          }
          if (shapeData && shapeIsTextType(shape.type, shape.name)) {
            let textFrame = shape.textFrame;
            textFrame.load("hasText")
            await context.sync()
            if (textFrame.hasText) {
              textFrame.load("textRange", 'autoSizeSetting')
              await context.sync()

              textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape
              await context.sync();

              let textRange = textFrame.textRange
              textRange.load("$all")
              await context.sync()
              if (textRange.text) {
                textRange.text = shapeData.SC.replace(/\*\*\*###/g, '\r')
              }
              await context.sync()
            }
          }
        }
      }
    })
  } catch (error) {
    console.log("updateSlideContentWithJSONData: " + error);
  }
}

// 根据slideId设置当前选中的slide
export async function setSlideSelectedBySlideId(slideId) {
  let slideData = []
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let presentation = context.presentation
      let slides = presentation.slides
      /**
         * find new slide, set the new slide selected
         */
      slides.load("items")
      await context.sync()
      let slidesItems = slides.items
      // let newSlideIndex = 0
      // for (let index = 0; index < slidesItems.length; index++) {
      //   const element = slidesItems[index]
      //   element.load('id')
      //   await context.sync()
      //   if (element.id === slideId) {
      //     newSlideIndex = index
      //   }
      // }
      // let newLastSlide = slidesItems[newSlideIndex]
      // newLastSlide.load('id')
      // await context.sync()
      // let newSlideId = newLastSlide.id

      presentation.setSelectedSlides([slideId])
      await context.sync();

      // let selectedSlides = context.presentation.getSelectedSlides()
      // selectedSlides.load("items")
      // await context.sync()
      // let currentSlide = null
      // if (selectedSlides.items.length > 0) {
      //   currentSlide = selectedSlides.items[0]
      // } 
      // if(currentSlide) {
      //   // 找到了，开始读取这个slide的shapeData
      //   slideData = await getSlideJSONData(context, currentSlide)

      //   /** Only for hasText shape */
      //   slideData = slideData.filter(item => item.SC.length > 0 && !(item.ST == 'GeometricShape' && item.SN.includes('Action Button: Custom')))
      // } else {
      //   // 没有找到选中的slide
      // }
    });
  } catch (error) {
    console.log("setSlideSelectedBySlideId: ", error)
  }
}

// 获取当前Slide的JSONData
export async function getCurrentSlideJSONData(Success) {
  let slideData = []
  PowerPoint = window.PowerPoint
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides()
      selectedSlides.load("items")
      await context.sync()
      let currentSlide = null
      if (selectedSlides.items.length > 0) {
        currentSlide = selectedSlides.items[0]
      }
      if (currentSlide) {
        // 找到了，开始读取这个slide的shapeData
        slideData = await getSlideJSONData(context, currentSlide)

        /** Only for hasText shape */
        slideData = slideData.filter(item => item.SC.length > 0 && !(item.ST == 'GeometricShape' && item.SN.includes('Action Button: Custom')))
      } else {
        // 没有找到选中的slide
      }
    });
  } catch (error) {
    console.log("getCurrentSlideJSONData: ", error)
  }
  if (typeof Success === "function") {
    Success(slideData)
  }
  // return allSlideText;
}

async function getSlideJSONData(context, slide) {
  let slideContent = []
  PowerPoint = window.PowerPoint
  try {
    slide.load("shapes")
    await context.sync()
    let shapeCollection = slide.shapes
    shapeCollection.load("items")
    await context.sync()
    let allShapes = shapeCollection.items

    for (let i = 0; i < allShapes.length; i++) {
      let shapeContent = {
        ST: "",
        SN: "",
        SC: ""
      }
      // 一个Shape的JSON数据
      let shape = allShapes[i];
      shape.load("$all");
      await context.sync();
      shapeContent.ST = shape.type
      shapeContent.SN = shape.name
      if (shapeIsTextType(shape.type, shape.name)) {
        // shape text frame
        let textFrame = shape.textFrame;
        textFrame.load("hasText");
        await context.sync();
        if (textFrame.hasText) {
          // text range
          textFrame.load("textRange");
          await context.sync();
          let textRange = textFrame.textRange;
          textRange.load("$all");
          await context.sync();
          // allSlideText += textRange.text;
          // allSlideText += "\n";
          shapeContent.SC = textRange.text
        }
      } else if (shape.type == "Group") {
        // todo
        shapeContent.SC = ''
      } else if (shape.type == "Image") {
        // todo
        shapeContent.SC = ''
      } else if (shape.type == "Table") {
        // todo
        shapeContent.SC = ''
      } else if (shape.type == "Unsupported") {
        // todo
        shapeContent.SC = ''
      } else {
        // todo
        shapeContent.SC = ''
      }
      slideContent.push(shapeContent)
    }
  } catch (error) {
    console.log("getSlideJSONData: " + error)
  }
  return slideContent
}

export function getTemplatePath() {
  /**
   * swirecocacola：swirecoke
   */
  let domain = ''
  let enterpriseDomainName = ''
  if (localStorage.getItem(userKeys.key_login_AccountName)) {
    const match = localStorage.getItem(userKeys.key_login_AccountName).match(/@([^@]+)\.com/)
    enterpriseDomainName = match ? match[1] : ''
  }
  if (enterpriseDomainName.includes('swirecocacola')) {
    domain = 'swirecoke'
  } else if (enterpriseDomainName.includes('botest') || enterpriseDomainName.includes('copilot')) {
    if (localStorage.getItem(userKeys.key_user_settings_swirecoke_template) === 'true') {
      domain = 'swirecoke'
    } else {
      domain = enterpriseDomainName
    }
  } else {
    domain = enterpriseDomainName
  }
  const titleTemplatePaths = ['template_title', 'template_title_swirecoke']
  const sectionHeaderTemplatePaths = ['template_section_headers', 'template_section_headers_swirecoke']
  const titleContentTemplatePaths = ['template_title_contents', 'template_title_contents_swirecoke']
  const endingTemplatePaths = ['template_ending', 'template_ending_swirecoke']

  let titleTemplatePath = titleTemplatePaths.find(item => item.includes(domain)) || 'template_title'
  let sectionHeaderTemplatePath = sectionHeaderTemplatePaths.find(item => item.includes(domain)) || 'template_section_headers'
  let titleContentTemplatePath = titleContentTemplatePaths.find(item => item.includes(domain)) || 'template_title_contents'
  let endingTemplatePath = endingTemplatePaths.find(item => item.includes(domain)) || 'template_ending'

  let pathObj = {
    title: titleTemplatePath,
    sectionHeader: sectionHeaderTemplatePath,
    titleContent: titleContentTemplatePath,
    ending: endingTemplatePath,
  }
  return pathObj
}